import React from 'react';
import './Page.css';
import outdoors from '../../img/outdoors.jpg';
import picnic from '../../img/picnic.jpg';

const about = props => (
            <div className="page">
                <h1>About Us</h1>
                <p className="page__about">Hello friends! Thanks for checking us out.</p>
                <p className="page__about">
                    Behind Leipers Fork RV Rental you’ll find a family who loves to travel,
                    to be outdoors and to create memories to hold for a lifetime. We make
                    it a priority to cultivate these loves, and RVing has been our favorite
                    way of accomplishing just that!
                </p>
                <img alt="rv1" className="page__full-width-img about__img" src={picnic}/>
                <p className="page__about">
                    Out of this passion, birthed Leipers Fork RV Rentals. We house our RVs
                    in the beautiful rolling hills of Leipers Fork, TN. Our mission is to
                    provide quality RV’s for families to utilize on their next adventure.
                    We make great service our priority with great communication, easy
                    transactions, well stocked essentials, cleanliness and competitive
                    pricing.
                </p>
                <img alt="rv2" className="page__full-width-img about__img" src={outdoors}/>
                <p className="page__about">
                    We would love the opportunity to host you in one of our rental units,
                    and help you create those lifelong memories!
                </p>
                <p className="page__about">Happy camping!</p>
            </div>
);

export default about;